module.exports = "<p>\n  payment-arrears-grid works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/payment-arrears/payment-arrears-grid/payment-arrears-grid.component.html
// module id = ./src/app/recovery/payment-arrears/payment-arrears-grid/payment-arrears-grid.component.html
// module chunks = main